import React from 'react';

export const PrivacyContent = () => (
  <>
    <p style={{ fontStyle: "italic", marginBottom: "1.5rem" }}>
      Effective Date: October 23, 2025
    </p>

    <p>
      Tower-Integrations ("we," "our," or "us") respects your
      privacy and is committed to protecting your personal
      information. This Privacy Policy explains how we collect,
      use, disclose, and safeguard your information when you visit
      our website.
    </p>

    <h3>1. Information We Collect</h3>
    <p>
      We may collect information about you in a variety of ways.
      The information we may collect includes:
    </p>
    <ul>
      <li>
        <strong>Personal Data:</strong> When you contact us
        directly, we may receive personal information such as your
        name, email address, phone number, and the contents of any
        message or attachments you may send us.
      </li>
      <li>
        <strong>Usage Data:</strong> We may automatically collect
        certain information when you visit our website, including
        your IP address, browser type, operating system, referring
        URLs, pages viewed, and the dates/times of your visits.
      </li>
    </ul>

    {/* ... (Abbreviated common sections standard in boilerplate) ... */}
    <h3>10. Contact Us</h3>
    <p>
      If you have questions or comments about this Privacy Policy,
      please contact us at:
    </p>
    <p>
      <strong>Email:</strong> dev.group@tower-integrations.com
    </p>
  </>
);

export const TermsContent = () => (
  <>
    <p style={{ fontStyle: "italic", marginBottom: "1.5rem" }}>
      Last Updated: October 23, 2025
    </p>

    <p>
      Welcome to Tower-Integrations. By accessing or using our
      website and services, you agree to be bound by these Terms
      of Service ("Terms"). Please read them carefully.
    </p>

    <h3>1. Acceptance of Terms</h3>
    <p>
      By accessing and using this website, you accept and agree to
      be bound by these Terms and our Privacy Policy. If you do
      not agree to these Terms, please do not use our website or
      services.
    </p>

     {/* ... (Abbreviated common sections standard in boilerplate) ... */}

    <h3>14. Contact Information</h3>
    <p>
      If you have any questions about these Terms, please contact
      us at:
    </p>
    <p>
      <strong>Email:</strong> dev.group@tower-integrations.com
    </p>
  </>
);
